import Cookies from 'js-cookie';
import Location from 'services/Location';

export const appendScriptToHead = (src: string, isSync: boolean): void => {
  const script = document.createElement('script');
  script.src = src;
  script.async = isSync;
  document.getElementsByTagName('head')[0].appendChild(script);
};

class Clearbit {
  init(): void {
    if (import.meta.env.VITE_APP_CLEARBIT && !Location.isTrackingRouteBlocked()) {
      appendScriptToHead(
        `https://tag.clearbitscripts.com/v1/${import.meta.env.VITE_APP_CLEARBIT}/tags.js`,
        true
      );
    }
  }

  async revealCompany(): Promise<any> {
    try {
      const response = await fetch(
        `https://reveal.clearbit.com/v1/companies/reveal?authorization=${import.meta.env.VITE_APP_CLEARBIT}`,
        { method: 'GET' }
      );

      if (response.status === 200) {
        const result = await response.json();
        return result;
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  async handleRevealData(): Promise<any> {
    let variantTest;

    try {
      // Fetch A/B testing version from reveal and pass it to API if exists
      const revealData = JSON.parse(Cookies.get('revealData'));
      variantTest = revealData?.test?.variant;
    } catch (error) {
      return null;
    }

    try {
      const clearbitReveal = await this.revealCompany();

      if (clearbitReveal && variantTest) {
        const updatedClearbitReveal = {
          ...clearbitReveal,
          websiteVariant: variantTest,
        };

        return updatedClearbitReveal;
      }

      return null;
    } catch (error) {
      return null;
    }
  }
}

export default new Clearbit();
